<template>
  <b-col cols="12" :xl="content.columns">
    <b-card :title="content.title">
      <b-card-text v-for="(text, index) in content.texts"
       :key="`card-${index}`"
      >
        <div v-html="text"></div>
      </b-card-text>
    </b-card>
  </b-col>
</template>
<script>
export default {
  props: ['content']
}
</script>

<style lang="sass" scoped>
  .lm-subtitle
    margin-bottom: 35px
</style>
